import { createContext, type ReactNode, useContext } from 'react'

type HistoryContextType = {
  showProfilePictures: boolean
  /** Cards rendered inside another feed (the messaging thread): bordered, unclamped, smaller title */
  embedded: boolean
}

const HistoryContext = createContext<HistoryContextType>({
  showProfilePictures: false,
  embedded: false
})

export const HistoryProvider = ({
  showProfilePictures = false,
  embedded = false,
  children
}: Partial<HistoryContextType> & { children: ReactNode }) => (
  <HistoryContext.Provider value={{ showProfilePictures, embedded }}>
    {children}
  </HistoryContext.Provider>
)

export const useHistoryContext = () => useContext(HistoryContext)
